import _indexOf from 'lodash.indexof';

export function indexOf<T = any>(collection: T[], key: T) {
  return _indexOf(collection, key);
}
